// extracted by mini-css-extract-plugin
export var link = "links-module--link--2wSAP";
export var btnLink = "links-module--btn-link--3LVXZ";
export var btnLinkSecondary = "links-module--btn-link-secondary--wZ0zL";
export var linkUnderlined = "links-module--linkUnderlined--3lfCS links-module--link--2wSAP";
export var linkInitial = "links-module--linkInitial--PKm3M links-module--link--2wSAP";
export var linkInitialUnderlined = "links-module--linkInitialUnderlined--32eM_ links-module--linkUnderlined--3lfCS links-module--link--2wSAP";